import { expertsTabs } from 'commons/constants';
import { expertsCurrentPageTypes, getExpertsTypes } from './types';

const { BROWSE, MY_EXPERTS } = expertsTabs;
const initialState = {
  [BROWSE]: {},
  [MY_EXPERTS]: {},
};

const expertsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case getExpertsTypes.REQUEST: {
      return { ...state, isLoading: true };
    }

    case getExpertsTypes.SUCCESS: {
      const { tab, currentPage, count, list } = payload;
      return { ...state, [tab]: { ...state[tab], list, count, currentPage }, isLoading: false };
    }

    case getExpertsTypes.FAILED: {
      return { ...state, error: payload, isLoading: false };
    }

    case expertsCurrentPageTypes.SET_CURRENT_PAGE: {
      const { page, tab } = payload;
      return { ...state, [tab]: { ...state[tab], currentPage: page } };
    }

    default:
      return state;
  }
};

export default expertsReducer;
